// extracted by mini-css-extract-plugin
export default {"default":"MUnkW","wrapper":"HJnFq","spin":"X8lIk"};